import React from "react";
import get from "lodash/get";

function View(props, { locals }) {
  const email = get(locals, "user.email");
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt="My Strength Book"
      />

      <div className="Steps" data-step="2">
        <div className="step"></div>
        <div className="step"></div>
        <div className="step"></div>
        <div className="step"></div>
      </div>

      <div className="frame narrow">
        <div className="head">
          <h1 className="alt">Confirm Email</h1>
        </div>

        <p className="centered-text small-text minus-top">
          We’ve sent you a confirmation email to {email}. Please click the link
          provided in the email to continue setting up your account.
        </p>

        <p className="centered-text small-text">
          If you don’t see your confirmation email in your inbox please check
          your spam or junk folders.
          {email && (
            <span>
              If you haven’t received your confirmation email we can <br />
              <a href={`/resend-verification/${email}`}>
                <b>resend your confirmation email</b>
              </a>
            </span>
          )}
        </p>
      </div>
    </div>
  );
}

const Step1 = (app) => {
  app.get("/step1", ({ res }, next) => {
    res.body = <View />;
  });
};

export default Step1;
